import { type Reducer } from 'redux';

export const extendReducerWithSwitch = <
    S,
    A extends { type: string }
>(
    baseReducer: Reducer<S, A>,
    extendedReducer: Reducer<S, A>
): Reducer<S, A> => {
    return (state: S | undefined, action: A): S => {
        const extendedState = extendedReducer(state, action);
        if (extendedState !== state && typeof state !== 'undefined') {
            return extendedState;
        }

        return baseReducer(state, action);
    };
};
